import { useEffect } from "react";

/** Renders nothing; tells the parent whenever `value` changes (safe to use inside render props). */
function ReportValue(props) {
  var onChange = props.onChange;
  var value = props.value;
  useEffect(
    function () {
      if (onChange) onChange(value);
    },
    [onChange, value]
  );
  return null;
}

export default ReportValue;
